import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { CustomOrder, CustomOrderHistoryList } from '@order/const';
import { StateUtils } from '@spartacus/core';
import { ORDERS_LIST, ORDER_DETAILS, ORDER_INVOICE_PAYMENT_ENTITY, ORDER_REPEAT, OrderState } from '../order-state';

export function getReducers(): ActionReducerMap<OrderState, any> {
  return {
    ordersList: StateUtils.loaderReducer<CustomOrderHistoryList>(ORDERS_LIST),
    orderDetails: StateUtils.loaderReducer<CustomOrder>(ORDER_DETAILS),
    orderInvoicePayment: StateUtils.entityLoaderReducer<void>(ORDER_INVOICE_PAYMENT_ENTITY),
    orderRepeat: StateUtils.loaderReducer<void>(ORDER_REPEAT),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<OrderState>> = new InjectionToken<
  ActionReducerMap<OrderState>
>('OrderReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
